import { useState } from "react";
import { observer } from "mobx-react-lite";
import { notifyApiErrors } from "../../../../core/helpers/helpers";
import { createResponseCenterDistribution } from "../../../../core/api/responsecenters/responsecenters";
import { ResponseCenterDistributionParams } from "../../../../core/api/responsecenters/types";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { DistributorForm } from "./DistributorForm";
import Button from "../../../../ui-lib/components/Button/Button";

const CreateDistributorModal = ({
  responseCenterId,
  onAdd,
}: {
  responseCenterId: string | number;
  onAdd: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();

  const [open, setOpen] = useState(false);

  const onSubmit = async (params: ResponseCenterDistributionParams) => {
    try {
      await createResponseCenterDistribution(
        responseCenterId,
        params,
        authenticatedRequest
      );
      notify({
        message: t("Messages:create_alarm_reception_distributor_success"),
      });
      onAdd();
      setOpen(false);
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.error);
    }
  };

  return (
    <>
      <Button
        variant="secondary"
        text={t("AlarmReceptions:add_distributor")}
        onClick={() => setOpen(true)}
      />
      {open && (
        <DistributorForm
          isOpen={open}
          labels={{
            title: t("AlarmReceptions:create_distributor"),
            description: t("AlarmReceptions:create_distributor_description"),
            submit: t("AlarmReceptions:create_distributor_submit"),
          }}
          onSubmit={onSubmit}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default observer(CreateDistributorModal);
